import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField
} from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function AddJudokaDialog({
  open,
  onClose,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        Ajouter un judoka
      </DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          label="Nom complet"
          placeholder="Ex : Lucas Dupont"
          margin="normal"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>
          Annuler
        </Button>

        <Button
          variant="contained"
          color="error"
        >
          Ajouter
        </Button>
      </DialogActions>
    </Dialog>
  );
}